import './styles.scss'

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'
import Twicpics from 'lib/tags/twicpics'
import ReadMore from 'lib/components/read-more'
import I18n from 'lib/i18n'

import Translate from './translate'
import ReviewLine from '../review-line'

import starIcon from '~/scenes/course/show/_assets/star-icon.svg'
import ArrowIcon from '~/scenes/course/show/_assets/arrow-icon.svg'
import { useValues } from 'kea'

import courseShowLogic from '~/scenes/course/show/logic'

const MAX_REVIEWS_MOBILE = 6
const MAX_REVIEWS_DESKTOP = 3

const LoadMoreSection = ({ loadMore }) => {
  return (
    <div className='load-more underline'>
      <div className='show-more-reviews-text' onClick={loadMore}>
        {I18n.t('courses.show.more_reviews')}
      </div>
      <div className='arrow-icon-container' onClick={loadMore}>
        <img className='arrow-icon' alt='arrow icon' src={`${ArrowIcon}`} width={16} height={16} />
      </div>
    </div>
  )
}

export default function Reviews ({ loadMore, reviews, translateReview, translating, user, isReviewModalOpen }) {
  const { isMobile, isTablet, isDesktop } = useValues(courseShowLogic)
  const { dpr } = useSelector(railsContext)

  const [isMobileBreakpoint, setIsMobileBreakpoint] = useState(false)
  const [isTabletBreakpoint, setIsTabletBreakpoint] = useState(false)
  const [isDesktopBreakpoint, setIsDesktopBreakpoint] = useState(false)
  const [reviewsToShow, setReviewsToShow] = useState([])

  const { reviewCount, reviewSum } = user || {}

  const reviewText = I18n.t('profiles.profile_layout.review_count', { count: reviewCount })

  useEffect(() => {
    setIsMobileBreakpoint(isMobile)
  }, [isMobile])

  useEffect(() => {
    setIsTabletBreakpoint(isTablet)
  }, [isTablet])

  useEffect(() => {
    setIsDesktopBreakpoint(isDesktop)
  }, [isDesktop])

  useEffect(() => {
    if (isReviewModalOpen) {
      setReviewsToShow(reviews.reviews)
    } else {
      if (isMobileBreakpoint || isTabletBreakpoint) {
        const reviewsToShow = reviews.reviews.slice(0, MAX_REVIEWS_MOBILE)
        setReviewsToShow(reviewsToShow)
      } else if (isDesktopBreakpoint) {
        const reviewsToShow = reviews.reviews.slice(0, MAX_REVIEWS_DESKTOP)
        setReviewsToShow(reviewsToShow)
      }
    }
  }, [isDesktopBreakpoint, isTabletBreakpoint, isMobileBreakpoint, isReviewModalOpen, reviews.reviews])

  return (
    <div id='reviews' className='reviews-section'>
      <div className='reviews-title'>{I18n.t('profiles.show_reviews.reviews')}</div>

      {isReviewModalOpen && reviewCount && reviewSum && (
        <ReviewLine reviewText={reviewText} reviewCount={reviewCount} reviewSum={reviewSum} withParentheses />
      )}

      <div className='review-cards-wrapper'>
        <div className='review-cards-container'>
          {reviewsToShow.length !== 0 &&
            reviewsToShow.map(review => (
              <div key={review.id} className='review-card-container'>
                <div className='card-header'>
                  <div className='reviewer-avatar-name-container'>
                    <div className='reviewer-avatar'>
                      <a href={review.url}>
                        <Twicpics src={review.avatar} width={50} height={50} alt={review.avatarAlt} dpr={dpr} />
                      </a>
                    </div>
                    <div className='reviewer-name-container'>
                      <div className='reviewer-name'>{review.name}</div>
                      <div className='review-created-at'>{review.createdAt}</div>
                    </div>
                  </div>
                  <div className='review-rating-container'>
                    <div className='review-rating-icon'>
                      <img className='star-icon' alt='star icon' src={`${starIcon}`} width={14} height={14} />
                    </div>
                    <div className='review-rating'>{review.stars}</div>
                  </div>
                </div>
                <div className='card-content'>
                  <div className='review-content-container'>
                    <div className='review-content'>
                      {isReviewModalOpen ? review.review : <ReadMore text={review.review} numberOfLines={5} noButton />}
                    </div>
                    <Translate review={review} translateReview={translateReview} translating={translating} />
                  </div>
                </div>
              </div>
            ))}
          {(isMobileBreakpoint || isTabletBreakpoint) && <LoadMoreSection loadMore={loadMore} />}
        </div>
        {isDesktopBreakpoint && <LoadMoreSection loadMore={loadMore} />}
      </div>
    </div>
  )
}

LoadMoreSection.propTypes = {
  loadMore: PropTypes.func
}

Reviews.propTypes = {
  reviews: PropTypes.object,
  translateReview: PropTypes.func,
  translating: PropTypes.bool,
  loadMore: PropTypes.func,
  isReviewModalOpen: PropTypes.bool,
  user: PropTypes.object
}
